import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import {
  CircularProgress,
  Container,
  Paper,
  Button,
  Typography,
  makeStyles,
  TextField,
  Box
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';

import auth from '../../../libs/auth';
import utils from '../../../libs/utils';
import Auth from '../../../libs/auth';

const useStyles = makeStyles(() => ({
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paper: {
    width: '95%',
    maxWidth: '500px',
    padding: '15px',
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    paddingTop: '20px',
    paddingBottom: '20px',
    marginBottom: '10px'
  }
}));


const Login = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const classes = useStyles();

  const login = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      await auth.login({email, password, role: 'admin'});
      history.replace('/admin/courses');
    }
    catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (Auth.getSession()?.user.admin === true) {
      history.replace('/admin/courses');
    }
  }, []);

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper}>
        <div className="mb-4">
          <img src="/devleague_logo.png" height="75" alt="Banner Logo" />
        </div>

        <Typography variant="h5" className="mb-3">Admin Login</Typography>

        <Box
          component="form"
          className={classes.form}
        >
          <TextField
            required
            label="Email"
            variant="outlined"
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)} 
          />
          <TextField
            required
            label="Password"
            type="password"
            variant='outlined'
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>

        <Button type="button"
                size="large"
                fullWidth={true}
                variant="contained"
                color="primary"
                disabled={isLoading}
                onClick={() => login()}>
          {isLoading && (<CircularProgress size={17} color="inherit" className="mr-2" />)}
          <span>Login</span>
        </Button>

        {!!errorMessage && (
          <div className="mt-4">
            <Alert
              onClose={() => setErrorMessage('')}
              severity="error">
              {errorMessage}
            </Alert>
          </div>
        )}
      </Paper>
    </Container>
  );
};

export default withRouter(Login);
